import cn from 'classnames'
import { observer } from 'mobx-react'
import React, { useEffect } from 'react'

import { AvatarLabelGroup } from '@flowwai-frontend/design-system'
import {
   useUserAppConfigStore,
   useUserAttendanceStatus
} from '@flowwai-frontend/bps-officer-web/iam'
import { useAppTheme } from '@flowwai-frontend/bps-officer-web/style-guide'
import { useReportBug } from '@flowwai-frontend/shared/common'

import NavFooterPopover from '../NavFooterPopover/NavFooterPopover'

import { containerClassName } from './styles'

interface Props {
   shouldShowAdminNavigationOption?: boolean
}

const NavFooter = (props: Props): React.ReactElement => {
   const { shouldShowAdminNavigationOption = true } = props

   const { theme } = useAppTheme()
   const { footer: navTheme } = theme.navbar

   const userStore = useUserAppConfigStore()
   const { getAttendanceStatus } = useUserAttendanceStatus()
   const reportBug = useReportBug()

   useEffect(() => {
      reportBug?.addCustomData('Email', userDetails?.email || '')
   }, [])

   const { userDetails } = userStore

   const renderUserDetails = (): React.ReactElement | null => {
      if (!userDetails) return null

      return (
         <div className='flex-grow truncate'>
            <AvatarLabelGroup
               description={''}
               name={userDetails.name || ''}
               type={userDetails.profilePicUrl ? 'Image' : 'Text'}
               shape={'Circular'}
               size={'Medium'}
               imageURL={userDetails.profilePicUrl || ''}
               status={getAttendanceStatus(userDetails)}
               labelClassName={'truncate'}
               labelDescriptionClassName={'truncate'}
            />
         </div>
      )
   }

   return (
      <div className={cn(containerClassName, navTheme.borderTopColor)}>
         {renderUserDetails()}
         <NavFooterPopover
            shouldShowAdminNavigationOption={shouldShowAdminNavigationOption}
         />
      </div>
   )
}

export default observer(NavFooter)
